import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/firebaseAuth';
import { ConversationList } from '../../features/messages/components/ConversationList/ConversationList';
import { ChatWindow } from '../../features/messages/components/ChatWindow/ChatWindow';
import { useConversations } from '../../features/messages/hooks';

const MessagesPage: React.FC = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [selectedConversationId, setSelectedConversationId] = useState<
    string | null
  >(null);

  // Fetch conversations here to pass selected one to ChatWindow
  const { conversations } = useConversations(currentUser?.uid);

  // Mobile view logic
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!currentUser)
    return (
      <div className="p-8 text-center">Please log in to view messages.</div>
    );

  const showList = !isMobileView || !selectedConversationId;
  const showChat = !isMobileView || selectedConversationId;

  const handleSelectConversation = (id: string) => {
    setSelectedConversationId(id);
    navigate(`/messages`);
  };

  const selectedConversation =
    conversations.find((c) => c.id === selectedConversationId) || null;

  return (
    <div className="flex h-[calc(100vh-64px)] overflow-hidden bg-gray-50 ">
      {/* Sidebar / List View */}
      {showList && (
        <div
          className={`${
            isMobileView
              ? 'w-full h-full'
              : 'w-full md:w-96 lg:w-[400px] xl:w-[420px]'
          } h-full border-r border-gray-200 bg-white flex-shrink-0`}
        >
          <ConversationList
            currentUserId={currentUser.uid}
            selectedConversationId={selectedConversationId}
            onSelectConversation={handleSelectConversation}
          />
        </div>
      )}

      {/* Chat Window */}
      {showChat && (
        <div
          className={`flex-1 flex flex-col h-full bg-white ${
            selectedConversationId ? 'flex' : 'hidden md:flex'
          }`}
        >
          <ChatWindow
            conversation={selectedConversation}
            currentUserId={currentUser.uid}
            onBack={() => setSelectedConversationId(null)}
          />
        </div>
      )}
    </div>
  );
};

export default MessagesPage;
